import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { StatelessSearchInput } from '@beef/ui-kit';
export var AddressInput = function AddressInput(_ref) {
  var disabled = _ref.disabled,
    onChange = _ref.onChange,
    onSearch = _ref.onSearch,
    onSelect = _ref.onSelect,
    value = _ref.value;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    options = _useState2[0],
    setOptions = _useState2[1];
  return /*#__PURE__*/React.createElement(StatelessSearchInput, {
    disabled: disabled
    // @ts-expect-error fixme later
    ,
    leftAside: null,
    onChange: onChange
    // @ts-expect-error fixme later
    ,
    onChangeOptions: setOptions
    // @ts-expect-error fixme later
    ,
    onSearch: onSearch
    // @ts-expect-error fixme later
    ,
    onSelect: onSelect,
    options: options,
    value: value,
    "data-t-id": "components-AddressInput"
  });
};